var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraduationCap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m501.191 422.355c5.781-1.684 10.215-6.778 10.755-13.137.701-8.254-5.422-15.514-13.677-16.215l-14.331-1.217v-193.598c.028-5.177-2.817-10.204-7.264-12.851l-226.97-136.627c-4.759-2.865-10.713-2.865-15.472 0l-226.968 136.627c-4.508 2.713-7.264 7.59-7.264 12.851s2.756 10.138 7.264 12.851l89.157 53.669v70.341c0 29.849 15.813 57.563 44.527 78.039 27.178 19.38 63.054 30.053 101.02 30.053s73.842-10.673 101.02-30.053c28.714-20.476 44.527-48.191 44.527-78.039v-70.341l66.421-39.983v225.713c0 8.284 6.716 15 15 15s15-6.716 15-15v-1.48l1.264 1.61c2.959 3.769 7.361 5.738 11.808 5.737 3.241 0 6.506-1.046 9.253-3.203 6.516-5.116 7.651-14.545 2.535-21.061zm-259.223-343.286 172.966 104.119h-48.064c-8.284 0-15 6.716-15 15s6.716 15 15 15h48.064l-172.966 104.119-197.883-119.119zm115.548 255.981c0 19.883-11.345 38.924-31.945 53.614-22.137 15.786-51.828 24.479-83.602 24.479s-61.465-8.693-83.602-24.479c-20.6-14.69-31.945-33.73-31.945-53.614v-52.282l107.811 64.899c4.759 2.865 10.713 2.865 15.472 0l107.812-64.899v52.282z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraduationCap);
export default __webpack_public_path__ + "static/media/graduation-cap.0473ba62460d74a444ba385e13dbe1ce.svg";
export { ForwardRef as ReactComponent };